import axios from "axios";
import { requestURLs } from "@/Environment";

export interface ClientErrorReportPayload {
  referenceId: string;
  errorName: string;
  errorMessage: string;
  errorStack?: string;
  pageUrl: string;
  userAgent?: string;
  userId?: string | null;
  userEmail?: string | null;
  organisationId?: string | null;
  metadata?: Record<string, unknown>;
}

export async function reportClientError(
  payload: ClientErrorReportPayload
): Promise<void> {
  try {
    const orgId =
      typeof localStorage !== "undefined"
        ? localStorage.getItem("organisation-id")
        : null;
    const resolvedOrgId = payload.organisationId || orgId || undefined;

    await axios.post(
      requestURLs.clientErrorLog,
      {
        ...payload,
        organisationId: resolvedOrgId,
      },
      {
        withCredentials: true,
        headers: {
          "Content-Type": "application/json",
          ...(resolvedOrgId ? { "organisation-id": resolvedOrgId } : {}),
        },
        timeout: 5000,
      }
    );
  } catch (err) {
    // Silently ignore reporting failures to never disrupt the error page
    console.warn("[reportClientError] Failed to send error log:", err);
  }
}
